/**
 * @function getTestEnvironment
 * @memberof Promega.Util
 * @description Returns a string representing the current testing environment, if there is one. Will be one of dev, testcontent, test, content, stage, local, or an empty string
 * @returns {Function} The name of the current testing environment
 */
export default function getTestEnvironment() {
    let environment = "";
    if (location.href.indexOf("//devcloud") > 0)
	    environment = "devcloud";
    else if (location.href.indexOf("//stagecloud") > 0)
        environment = "stagecloud";
    else if (location.href.indexOf("//testcloud") > 0)
        environment = "testcloud";
    else if (location.href.indexOf("//prodcloud") > 0)
        environment = "prodcloud";
    else if (location.href.indexOf("//hotfixcloud") > 0)
        environment = "hotfixcloud";
    else if (location.href.indexOf("//stagecontent") > 0)
        environment = "stagecontent";
    else if (location.href.indexOf("//cm-testcloud") > 0)
        environment = "cm-testcloud";
    else if (location.href.indexOf("//cm-prodcloud") > 0)
        environment = "cm-prodcloud";
    else if (location.href.indexOf("//cm-hotfixcloud") > 0)
        environment = "cm-hotfixcloud";
    else if (location.href.indexOf("//dev.") > 0)
        environment = "dev";
    else if (location.href.indexOf("//testcontent.") > 0)
        environment = "testcontent";
    else if (location.href.indexOf("//test.") > 0)
        environment = "test";
    else if (location.href.indexOf("//content.") > 0)
        environment = "content";
    else if (location.href.indexOf("//stage.") > 0)
        environment = "stage";
    else if (location.href.indexOf("//local.") > 0)
        environment = "local";
    else if (location.href.indexOf("//localcontent") > 0)
        environment = "localcontent";
    return environment;
}
